export interface StaffAPIResponse {
  staff: StaffModel[];
}

export interface StaffModel {
  staID: string;
  name: string;
  initials: string;
  email: string;
  attorneyFlag: 0 | 1;
  hasSignatureImage: boolean;
}

export interface Signature {
  name: string;
  sigBlock: string;
  letterSig: string;
  signatureImage: string;
  signatureImageW: number;
  signatureImageH: number;
}

export enum SignatureType {
  PLEADING = 'pleading',
  LETTER = 'letter',
  IMAGE = 'image',
}
